import React from 'react'

import { Box, Typography } from '@material-ui/core'

import useSupplierJourney from 'hooks/useSupplierJourney'

import useStyles from '../../styles'

const DescriptionBox = () => {
  const { stepInfo, linkInvalid } = useSupplierJourney()
  const classes = useStyles()

  if (linkInvalid) return null

  return (
    <Box
      minHeight="52vh"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box display="flex" justifyContent="center" width="100%">
        {stepInfo?.video && (
          <>
            <Box position="relative" width="100%" height="200px">
              <iframe
                title={stepInfo?.video.title}
                src={`${stepInfo?.video.url}?autoplay=1&loop=1&autopause=0`}
                allow="autoplay; fullscreen"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0,
                }}
              ></iframe>
            </Box>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </>
        )}
      </Box>
      <Box p={4}>
        <Typography className={classes.text} variant="subtitle1">
          {stepInfo?.text}
        </Typography>
      </Box>
    </Box>
  )
}

export default DescriptionBox
